import React, { useState } from "react";
import { motion } from "framer-motion";
import '../Scc/CustomerInquiry.scss';  // Import SCSS file

const CustomerInquiry = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    inquiry: "",
    message: "",
  });

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      window.Email.send({
        SecureToken: "df6437ec-1da4-4668-9ca8-278dd232a236", // Replace with your own
        To: "tubeyou30603@gmail.com",
        From: "basu.9901.annigeri@gmail.com",
        Subject: `New Inquiry from ${formData.name}`,
        Body: ` 
          <strong>Name:</strong> ${formData.name}<br/>
          <strong>Email:</strong> ${formData.email}<br/>
          <strong>Inquiry:</strong> ${formData.inquiry}<br/>
          <strong>Message:</strong><br/>${formData.message}
        `,
      }).then((message) => {
        if (message === "OK") {
          alert("Your inquiry has been sent successfully.");
          setFormData({ name: "", email: "", inquiry: "", message: "" });
        } else {
          alert("Failed to send: " + message);
        }
      });
    } catch (error) {
      alert("Unexpected error: " + error.message);
    }
  };

  return (
    <div className="customer-inquiry min-h-screen flex items-center justify-center p-4">
      <motion.div
        className="form-container w-full max-w-md bg-white p-6 rounded-lg shadow-lg"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4 }}
      >
        <h2 className="form-title text-3xl font-semibold text-center mb-6">Customer Inquiry Form</h2>
        <form onSubmit={handleSubmit}>
          <label className="form-label text-lg">Your Name</label>
          <input
            type="text"
            name="name"
            required
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter your name"
            className="form-input"
          />

          <label className="form-label text-lg">Your Email</label>
          <input
            type="email"
            name="email"
            required
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter your email"
            className="form-input"
          />

          <label className="form-label text-lg">Product/Service Inquiry</label>
          <input
            type="text"
            name="inquiry"
            required
            value={formData.inquiry}
            onChange={handleChange}
            placeholder="What are you interested in?"
            className="form-input"
          />

          <label className="form-label text-lg">Your Message</label>
          <textarea
            name="message"
            required
            value={formData.message}
            onChange={handleChange}
            placeholder="Type your message here..."
            className="form-textarea"
          ></textarea>

          <button
            type="submit"
            className="submit-btn w-full bg-blue-600 hover:bg-blue-500 text-white py-3 rounded-md font-medium transition duration-300"
          >
            Submit Inquiry
          </button>
        </form>
      </motion.div>
    </div>
  );
};

export default CustomerInquiry;
